'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bus = new _vue2.default();

module.exports = bus;


//////////////////
// WEBPACK FOOTER
// ./~/vue-pagination-2/compiled/bus.js
// module id = 131
// module chunks = 5